import React, { createContext, useState, useCallback, useMemo } from 'react';
import SnackBarContainer from './SnackBarContainer';

export const SnackBarContext = createContext(null);

export const SnackBarProvider = ({ children }) => {
  const [snackBars, setSnackBars] = useState([]);
   const maxVisible = 1;

  const removeSnackBar = useCallback((id) => {
    setSnackBars((prev) => prev.filter((item) => item.id !== id));
  }, []);

  const showSnackBar = useCallback((options) => {
    const id = Math.random().toString(36).substring(2, 9) + Date.now();
    const newSnackBar = {
      id,
      duration: 2000,
      type: 'info',
      ...options,
    };

    setSnackBars((prev) => {
      const updated = [...prev, newSnackBar];
      if (updated.length > maxVisible) {
        return updated.slice(-maxVisible);
      }
      return updated;
    });

    return id;
  }, []);

  const contextValue = useMemo(() => ({
    showSnackBar,
    removeSnackBar
  }), [showSnackBar, removeSnackBar]);

  return (
    <SnackBarContext.Provider value={contextValue}>
      {children}
      <SnackBarContainer snackBars={snackBars} onDismiss={removeSnackBar} />
    </SnackBarContext.Provider>
  );
};
